import axios from "axios";
import constants from "../constants";

export const getAutoRenewals = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/shipments/getAutoRenewals`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};